<template>
  <span class="emoji_wrapper">
    <svg :style="style">
      <use :xlink:href="'#' + name"></use>
    </svg>
  </span>
</template>
<script>
export default {
  computed: {
    style: function() {
      return {
        width: this.size ? this.size : 25 + "px",
        height: this.size ? this.size : 25 + "px"
      };
    }
  },
  props: {
    name: { default: "@happy" },
    size: { default: 25 }
  }
};
</script>
